import React, { useContext } from 'react'
import OxygenAvatar from '@8x8/oxygen-avatar'

import { AVATAR_COLORS } from '~/core/constants'
import { ThemeContext } from 'styled-components'

const getAvatarColor = name => {
  if (!name) {
    return AVATAR_COLORS[0]
  }

  let colorIndex = 0
  let nameHash = 0

  for (const s of name) {
    nameHash += s.codePointAt(0)
  }

  colorIndex = nameHash % AVATAR_COLORS.length

  return AVATAR_COLORS[colorIndex]
}

const Avatar = ({ useDynamicColor, ...rest }) => {
  const theme = useContext(ThemeContext)
  const avatarName = rest.name || ''

  return (
    <OxygenAvatar
      {...rest}
      name={avatarName}
      theme={{
        avatarBackgroundColor: useDynamicColor
          ? getAvatarColor(avatarName)
          : theme.colorIcon,
        initialsColor: useDynamicColor
          ? 'white'
          : theme.colorSelected
      }}
    />
  )
}

export default Avatar
